import { render, staticRenderFns } from "./userorgCourse.vue?vue&type=template&id=11aaebbe&scoped=true"
import script from "./userorgCourse.vue?vue&type=script&lang=js"
export * from "./userorgCourse.vue?vue&type=script&lang=js"
import style0 from "./userorgCourse.vue?vue&type=style&index=0&id=11aaebbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11aaebbe",
  null
  
)

export default component.exports